export default __webpack_public_path__ + "static/MediaContentSix-d4ac85b08cbfdf1780434f7bf3eb3e0d.webp";